import { useState } from "react";
import { motion, AnimatePresence } from "framer-motion";
import { X } from "lucide-react";
import { GALLERY, GALLERY_FILTERS } from "@/data/salon";

export const Gallery = () => {
  const [filter, setFilter] = useState("all");
  const [lightbox, setLightbox] = useState(null);
  const items = filter === "all" ? GALLERY : GALLERY.filter((g) => g.tag === filter);

  return (
    <section id="gallery" data-testid="gallery-section" className="py-24 sm:py-32 bg-cream">
      <div className="max-w-7xl mx-auto px-5 sm:px-8">
        <div className="flex flex-col sm:flex-row sm:items-end justify-between gap-6 mb-12">
          <div>
            <span className="font-mono text-xs uppercase tracking-[0.3em] text-pink">The Portfolio</span>
            <h2 className="mt-5 font-serif text-4xl sm:text-5xl lg:text-6xl text-ink leading-[1.05]">Considered work</h2>
          </div>
          <div className="flex flex-wrap gap-2">
            {GALLERY_FILTERS.map((f) => (
              <button
                key={f}
                data-testid={`gallery-filter-${f}`}
                onClick={() => setFilter(f)}
                className={`rounded-full px-4 py-2 font-mono text-[10px] uppercase tracking-[0.15em] transition-all border ${
                  filter === f ? "bg-pink text-ink border-pink" : "text-ink/60 border-pink/25 hover:border-pink"
                }`}
              >
                {f}
              </button>
            ))}
          </div>
        </div>

        <motion.div layout className="columns-2 md:columns-3 gap-4 space-y-4">
          <AnimatePresence>
            {items.map((g, i) => (
              <motion.button
                layout
                key={g.id}
                initial={{ opacity: 0, scale: 0.9 }}
                animate={{ opacity: 1, scale: 1 }}
                exit={{ opacity: 0, scale: 0.9 }}
                transition={{ duration: 0.4, delay: (i % 6) * 0.04 }}
                onClick={() => setLightbox(g.src)}
                data-testid="gallery-item"
                className="group relative block w-full overflow-hidden rounded-2xl border border-pink/20 break-inside-avoid"
              >
                <img src={g.src} alt={g.tag} className="w-full object-cover transition-transform duration-700 group-hover:scale-105" />
                <div className="absolute inset-0 bg-ink/0 group-hover:bg-ink/20 transition-colors" />
                <span className="absolute bottom-3 left-3 font-mono text-[10px] uppercase tracking-[0.2em] text-cream opacity-0 group-hover:opacity-100 transition-opacity">{g.tag}</span>
              </motion.button>
            ))}
          </AnimatePresence>
        </motion.div>
      </div>

      <AnimatePresence>
        {lightbox && (
          <motion.div
            initial={{ opacity: 0 }} animate={{ opacity: 1 }} exit={{ opacity: 0 }}
            onClick={() => setLightbox(null)}
            className="fixed inset-0 z-[60] flex items-center justify-center bg-ink/90 p-6 backdrop-blur-sm"
          >
            <button className="absolute top-6 right-6 text-cream"><X className="h-8 w-8" /></button>
            <motion.img
              initial={{ scale: 0.9 }} animate={{ scale: 1 }}
              src={lightbox} alt="preview"
              className="max-h-[85vh] max-w-full rounded-2xl object-contain"
            />
          </motion.div>
        )}
      </AnimatePresence>
    </section>
  );
};
